import { useTranslation } from 'react-i18next';

import { OnboardingStyle } from '../onboarding/onboarding-style';
import { CancelledStyles } from '../cancelled/cancelled-style';
import { AuthHeader, ContentLayout } from '../../../global-styles/layout';
import { BodyText } from '../../../components/typography/typography';
import { images } from '../../../assets/images/images';

const Landing = () => {
  const { t } = useTranslation(['landing']);

  return (
    <ContentLayout data-cy="landing-page">
      <CancelledStyles>
        <OnboardingStyle>
          <div className="onboarding-top">
            <AuthHeader>
              <div className="auth-header-title">
                <BodyText as="p" weight={600}>
                  {t('text1')}
                </BodyText>
              </div>
              <div className="auth-header-title">
                <BodyText as="p" weight={600}>
                  {t('text2')}
                </BodyText>
              </div>
            </AuthHeader>
            <div className="cancelled-img">
              <img src={images.cars} alt="" />
            </div>
          </div>
        </OnboardingStyle>
      </CancelledStyles>
    </ContentLayout>
  );
};

export default Landing;
